export default "__VITE_ASSET__4569d58a__"